module.exports = __webpack_public_path__ + "img/Medical-Instant-Translation-Logo.b7064b6c.png";